<template>
    <div  class="list-div">
        <div class="form base-form-div">
            <el-form size="mini" :rules="rules" :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                <el-form-item label="动画名称:" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
            </el-form>
            <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">添加</el-button>
        </div>
        <div class="collapse-room">
            <el-collapse accordion>
                <el-collapse-item v-for="(item, index) in list" :title="item.name">
                    <div class="operate-div">
                        <el-button size="mini" type="primary" @click="addView(item.list)">添加书签</el-button>
                        <el-button :disabled="item.list.length<1" size="mini" type="primary" @click="startPlay(item.list)">播放动画</el-button>
                    </div>
                    <div class="list">
                        <div v-for="(view, index) in item.list" class="item">
                            <el-image @click="flyToView(view)" :src="view.data"></el-image>
                            <div class="operate">
                                <div class="interval-div">
                                    <span>动画延迟(秒)</span>
                                    <el-input-number :min="0" :step="0.1" size="mini"
                                        v-model="view.interval"></el-input-number>
                                </div>
                                <div>
                                    <svg-icon @click="deleteView(index, item.list)" class="icon" icon-class="p-clear" />
                                </div>
                            </div>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>

<script>
import Workflow from "@/utils/cesiumBD/utils/Workflow"
export default {
    data() {
        return {
            ruleForm: {
                name: ""
            },
            rules: {
                name: [
                    { required: true, message: "请输入动画名称", trigger: "blur" },
                ],
            },
            list: []
        };
    },

    mounted() {

    },

    methods: {
        //播放动画
        //{fun:fun1,delay:200,params:1}
        startPlay(list) {
            var funs = [];
            for (let i = 0; i < list.length; i++) {
                funs.push({ fun: this.createPromisFly, delay: list[i].interval * 1000, params: list[i] });
            }

            var ws = new Workflow(funs);
            ws.runWorkflow();

        },
        createPromisFly(item) {
            var view = item.view;
            let opts = {};
            item.complete = false;
            opts.destination = Cesium.Cartesian3.fromDegrees(view.x, view.y, view.z); //经度、纬度、高度 
            opts.orientation = {
                heading: Cesium.Math.toRadians(Cesium.defaultValue(view.heading, 0)), //绕垂直于地心的轴旋转
                pitch: Cesium.Math.toRadians(Cesium.defaultValue(view.pitch, -90)), //绕纬度线旋转
                roll: Cesium.Math.toRadians(Cesium.defaultValue(view.roll, 0)) //绕经度线旋转
            };

            opts.complete = function () {
                item.complete = true;
            }
            return new Promise((resolve) => {
                viewer.camera.flyTo(opts);
                setInterval(() => {
                    if (item.complete) {
                        resolve();
                    }
                }, 100);
            });
        },
        addView(list) {
            var url = DBmap.expImage();
            var view = DBmap.getCameraView();
            var item = new Object();
            item.data = url;//dataURLtoBlob(url);
            item.interval = 1; //默认一秒
            item.view = view;
            item.complete = false;
            list.push(item);
         
            console.log(view);

        },
        deleteView(index, list) {
            list.splice(index, 1);
        },
        flyToView(item) {
            var view = item.view;
            DBmap.setCameraView(view);
        },
        isRepeat() {
            var name = this.ruleForm.name;
            var has = this.list.filter(v => {
                return v.name == name;
            });

            return has.length > 0 ? true : false;
        },
        submitForm(formName) {
            var has = this.isRepeat();
            if (has) {
                this.$message({
                    message: "该动画名称已经存在，请重新命名！",
                    type: "error",
                });
                return;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var item = new Object();
                    item.list = [];
                    item.name = this.ruleForm.name;
                    this.list.push(item);

                    this.$message({
                        message: "添加成功",
                        type: "success",
                    });
                    this.ruleForm.name = "";
                } else {
                    return false;
                }
            });
        },

    },
};
</script>

<style lang="scss" scoped>
.list-div {
    height: 100%;
}

.form {
    margin-bottom: 20px;
    padding: 0 0 0 0;
}

.collapse-room {
    height: 540px;
    overflow-y: auto;
}


.operate-div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.list {
    .item {
        position: relative;
        cursor: pointer;

        .operate {
            position: absolute;
            left: 0;
            bottom: 10px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 0 10px;
            box-sizing: border-box;
            background-color: rgba(#000, 0.3);

            .icon {
                width: 20px;
                height: 20px;
            }
        }
    }
}
</style>
<style lang="scss">
.interval-div {
    display: flex;
    align-items: center;
    justify-content: center;

    // span {
    //     margin-right: 10px;
    // }

    .el-input-number {
        width: 100px !important;
    }
}
.list-div {
    .el-input {
        width: auto;
    }

    .el-image {
        height: 130px;
        width:100%;
    }
}
</style>